<template>
  <div class="w-full h-full">
    <!-- <div v-if="loader == true" class="w-full h-full"></div> -->
    <form
      @submit.prevent="submitAdditionalDetails"
      @click.stop
      class="w-full h-auto bg-white p-5"
    >
      <div class="flex flex-col gap-3 lg:gap-5">
        <div class="flex flex-col gap-3">
          <div class="flex justify-between items-center">
            <h2 class="text-xl font-semibold capitalize text-heading">
              additional information
            </h2>
            <div>
              <button
                v-if="submitAdditional == true"
                @click="toggleEdit"
                type="button"
                class="px-5 py-1 btn text-[16px] rounded-md"
              >
                Edit
              </button>
              <button
                v-if="toggle_edit == true"
                @click="
                  disableStatus = true;
                  submitAdditional = true;
                  toggle_edit = false;
                "
                type="button"
                class="px-5 py-1 btn text-[16px] rounded-md"
              >
                Close
              </button>
            </div>
          </div>

          <div class="flex flex-col gap-3 lg:flex-row lg:justify-between">
            <div class="w-full flex flex-col gap-3">
              <label for="category" class="text-sm input_label"
                >Category <span class="span-color">*</span></label
              >
              <input
                :class="{
                  'cursor-not-allowed bg-disable': disableStatus === true,
                  'cursor-pointer bg-primary2': disableStatus === false,
                }"
                type="text"
                class="w-full px-3 py-2 text-sm font-normal text-input bg-primary2 bg-clip-padding focus:ring-0 input-border rounded-md shadow-md focus:outline-none"
                v-model="category"
                :disabled="disableStatus"
                placeholder="Enter category"
                required
              />
              <!-- <select
              :class="{
                      'cursor-not-allowed bg-disable': disableStatus === true,
                      'cursor-pointer bg-primary2': disableStatus === false,
                    }"
                class="block w-full py-2 text-sm font-normal text-input bg-primary2 bg-clip-padding bg-no-repeat focus:ring-0  input-border rounded-md shadow-md focus:outline-none"
                aria-label="Default select example"
                required
                v-model="category"
              >
                <option value="" selected disabled>Select</option>
                <option value="General">General</option>
                <option value="no">No</option>
              </select> -->
            </div>
            <div class="w-full flex flex-col gap-3">
              <label for="name" class="text-sm input_label"
                >Name as in Aadhar card <span class="span-color">*</span></label
              >
              <input
                :class="{
                  'cursor-not-allowed bg-disable': disableStatus === true,
                  'cursor-pointer bg-primary2': disableStatus === false,
                }"
                type="text"
                class="w-full px-3 py-2 text-sm font-normal text-input bg-primary2 bg-clip-padding focus:ring-0 input-border rounded-md shadow-md focus:outline-none"
                v-model="aadhar_card_name"
                :disabled="disableStatus"
                placeholder="Enter Name in Aadhar card"
                required
              />
            </div>
          </div>
          <div class="flex flex-col gap-2 lg:flex-row lg:justify-between">
            <div class="w-full flex flex-col gap-3">
              <label for="blood_group" class="text-sm input_label"
                >Blood Group <span class="span-color">*</span></label
              >
              <select
                :class="{
                  'cursor-not-allowed bg-disable': disableStatus === true,
                  'cursor-pointer bg-primary2': disableStatus === false,
                }"
                class="block w-full py-2 text-sm font-normal text-input bg-primary2 bg-clip-padding bg-no-repeat focus:ring-0 input-border rounded-md shadow-md focus:outline-none"
                aria-label="Default select example"
                required
                :disabled="disableStatus"
                v-model="blood_group"
              >
                <option value="" selected disabled>Select</option>
                <option value="A+">A+</option>
                <option value="A-">A-</option>
                <option value="B+">B+</option>
                <option value="B-">B-</option>
                <option value="O+">O+</option>
                <option value="O-">O-</option>
                <option value="AB+">AB+</option>
                <option value="AB-">AB-</option>
              </select>
            </div>
            <div class="w-full flex flex-col gap-3">
              <label for="mother_tongue" class="text-sm input_label"
                >Mother Tongue <span class="span-color">*</span></label
              >
              <select
                :class="{
                  'cursor-not-allowed bg-disable': disableStatus === true,
                  'cursor-pointer bg-primary2': disableStatus === false,
                }"
                class="block w-full py-2 text-sm font-normal text-input bg-primary2 bg-clip-padding bg-no-repeat focus:ring-0 input-border rounded-md shadow-md focus:outline-none"
                aria-label="Default select example"
                required
                :disabled="disableStatus"
                v-model="mother_tongue"
              >
                <option value="" selected disabled>Select</option>
                <option value="Tamil">Tamil</option>
                <option value="English">English</option>
                <option value="Malayalam">Malayalam</option>
                <option value="Kanadam">Kanadam</option>
                <option value="Telungu">Telungu</option>
                <option value="Hindi">Hindi</option>
              </select>
            </div>
            <div class="w-full flex flex-col gap-3">
              <label for="marital_status" class="text-sm input_label"
                >Marital status <span class="span-color">*</span></label
              >
              <select
                :class="{
                  'cursor-not-allowed bg-disable': disableStatus === true,
                  'cursor-pointer bg-primary2': disableStatus === false,
                }"
                class="block w-full py-2 text-sm font-normal text-input bg-primary2 bg-clip-padding bg-no-repeat focus:ring-0 input-border rounded-md shadow-md focus:outline-none"
                aria-label="Default select example"
                required
                :disabled="disableStatus"
                v-model="marital_status"
              >
                <option value="" selected disabled>Select</option>
                <option value="Married">Married</option>
                <option value="Unmarried">UnMarried</option>
              </select>
            </div>
            <div class="w-full flex flex-col gap-3">
              <label for="abc_id" class="text-sm input_label"
                >ABC id <span class="span-color">*</span></label
              >
              <input
                :class="{
                  'cursor-not-allowed bg-disable': disableStatus === true,
                  'cursor-pointer bg-primary2': disableStatus === false,
                }"
                type="text"
                class="w-full px-3 py-2 text-sm font-normal text-input bg-primary2 bg-clip-padding focus:ring-0 input-border rounded-md shadow-md focus:outline-none"
                v-model="abc_id"
                :disabled="disableStatus"
                onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                maxlength="10"
                placeholder="Enter your ABC id"
                required
              />
            </div>
          </div>
        </div>
        <!-- Parent details  -->
        <div>
          <div class="flex flex-col gap-2 lg:gap-4">
            <div class="flex flex-col gap-2 lg:flex-row lg:gap-5 w-full">
              <div class="w-full flex flex-col gap-3">
                <label for="father_title" class="text-sm input_label"
                  >Father's Title <span class="span-color">*</span></label
                >
                <select
                  :class="{
                    'cursor-not-allowed bg-disable': disableStatus === true,
                    'cursor-pointer bg-primary2': disableStatus === false,
                  }"
                  class="block w-full py-2 text-sm font-normal text-input bg-primary2 bg-clip-padding bg-no-repeat focus:ring-0 input-border rounded-md shadow-md focus:outline-none"
                  aria-label="Default select example"
                  required
                  :disabled="disableStatus"
                  v-model="father_title"
                >
                  <option value="" selected disabled>Select</option>
                  <option value="Mr">Mr</option>
                  <option value="Mrs">Mrs</option>
                  <option value="Miss">Miss</option>
                </select>
              </div>
              <div class="w-full flex flex-col gap-3">
                <label for="father_name" class="text-sm input_label"
                  >Father's Name <span class="span-color">*</span></label
                >
                <input
                  :class="{
                    'cursor-not-allowed bg-disable': disableStatus === true,
                    'cursor-pointer bg-primary2': disableStatus === false,
                  }"
                  type="text"
                  class="w-full px-3 py-2 text-sm font-normal text-input bg-primary2 bg-clip-padding focus:ring-0 input-border rounded-md shadow-md focus:outline-none"
                  v-model="father_name"
                  :disabled="disableStatus"
                  placeholder="Enter your Father's Name"
                  required
                />
              </div>
              <div class="w-full"></div>
            </div>
            <div class="flex flex-col gap-2 lg:flex-row lg:gap-5 w-full">
              <div class="w-full flex flex-col gap-3">
                <label for="mother_title" class="text-sm input_label"
                  >Mother's Title <span class="span-color">*</span></label
                >
                <select
                  :class="{
                    'cursor-not-allowed bg-disable': disableStatus === true,
                    'cursor-pointer bg-primary2': disableStatus === false,
                  }"
                  class="block w-full py-2 text-sm font-normal text-input bg-primary2 bg-clip-padding bg-no-repeat focus:ring-0 input-border rounded-md shadow-md focus:outline-none"
                  aria-label="Default select example"
                  required
                  v-model="mother_title"
                  :disabled="disableStatus"
                >
                  <option value="" selected disabled>Select</option>
                  <option value="Mr">Mr</option>
                  <option value="Mrs">Mrs</option>
                  <option value="Miss">Miss</option>
                </select>
              </div>
              <div class="w-full flex flex-col gap-3">
                <label for="mother_name" class="text-sm input_label"
                  >Mother's Name <span class="span-color">*</span></label
                >
                <input
                  :class="{
                    'cursor-not-allowed bg-disable': disableStatus === true,
                    'cursor-pointer bg-primary2': disableStatus === false,
                  }"
                  type="text"
                  class="w-full px-3 py-2 text-sm font-normal text-input bg-primary2 bg-clip-padding focus:ring-0 input-border rounded-md shadow-md focus:outline-none"
                  v-model="mother_name"
                  :disabled="disableStatus"
                  placeholder="Enter your Mother's name"
                  required
                />
              </div>
              <div class="w-full"></div>
            </div>
            <div class="flex flex-col gap-2 lg:flex-row lg:gap-5 w-full">
              <div class="w-full flex flex-col gap-3">
                <label for="guardian_title" class="text-sm input_label"
                  >Guardian's Title <span class="span-color">*</span></label
                >
                <select
                  :class="{
                    'cursor-not-allowed bg-disable': disableStatus === true,
                    'cursor-pointer bg-primary2': disableStatus === false,
                  }"
                  class="block w-full py-2 text-sm font-normal text-input bg-primary2 bg-clip-padding bg-no-repeat focus:ring-0 input-border rounded-md shadow-md focus:outline-none"
                  aria-label="Default select example"
                  required
                  v-model="guardian_title"
                  :disabled="disableStatus"
                >
                  <option value="" selected disabled>Select</option>
                  <option value="Mr">Mr</option>
                  <option value="Mrs">Mrs</option>
                  <option value="Miss">Miss</option>
                </select>
              </div>
              <div class="w-full flex flex-col gap-3">
                <label for="guardian_name" class="text-sm input_label"
                  >Guardian's Name <span class="span-color">*</span></label
                >
                <input
                  :class="{
                    'cursor-not-allowed bg-disable': disableStatus === true,
                    'cursor-pointer bg-primary2': disableStatus === false,
                  }"
                  type="text"
                  class="w-full px-3 py-2 text-sm font-normal text-input bg-primary2 bg-clip-padding focus:ring-0 input-border rounded-md shadow-md focus:outline-none"
                  v-model="guardian_name"
                  :disabled="disableStatus"
                  placeholder="Enter Name of the Guardian/Spouse"
                  required
                />
              </div>
              <div class="w-full flex flex-col gap-3">
                <label for="guardian_phone_number" class="text-sm input_label"
                  >Guardian's Mobile Number
                  <span class="span-color">*</span></label
                >
                <div class="flex">
                  <select
                    :class="{
                      'cursor-not-allowed bg-disable': disableStatus === true,
                      'cursor-pointer bg-primary2': disableStatus === false,
                    }"
                    id="country-form"
                    v-model="selectedCountryCode"
                    @change="handleChange"
                    :disabled="disableStatus"
                    class="form-control block w-20 px-3 py-2 text-sm font-normal text-input bg-primary2 bg-clip-padding focus:ring-0 input-border rounded-md shadow-md focus:outline-none"
                  >
                    <option
                      v-for="country in countryCodes"
                      :key="country.code"
                      :value="country.code"
                    >
                      {{
                        selectedCountryCode === country.code
                          ? country.code
                          : `${country.name} (${country.code})`
                      }}
                    </option>
                  </select>
                  <input
                    :class="{
                      'cursor-not-allowed bg-disable': disableStatus === true,
                      'cursor-pointer bg-primary2': disableStatus === false,
                    }"
                    type="tel"
                    class="form-control block w-full px-3 py-2 text-sm font-normal text-input bg-primary2 bg-clip-padding focus:ring-0 input-border rounded-md shadow-md focus:outline-none"
                    onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                    id="Phone_no"
                    placeholder="Enter Guardian's Phone no*"
                    maxlength="10"
                    v-model="guardian_phone_number"
                    :disabled="disableStatus"
                    required
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="submit_button == false" class="flex justify-between w-full">
          <div class="text-success text-xl">
            <p v-if="message">{{ message }}</p>
          </div>
          <div class="flex justify-end items-center">
            <button
              :class="{
                'cursor-not-allowed bg-disable dark_text': disableStatus === true,
                'cursor-pointer btn': disableStatus === false,
              }"
              :disabled="disableStatus"
              type="submit"
              class="px-5 py-1 btn text-[16px] rounded-md"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import axios from "axios";
import { mapActions, mapGetters } from "vuex";
import countryCodeMixins from "@/mixins/countryCodeMixins";
export default {
  name: "AdditionalView",
  props: ["complete_status"],
  data() {
    return {
      selectedCountryCode: "+91",
      category: "",
      aadhar_card_name: "",
      blood_group: "",
      mother_tongue: "",
      marital_status: "",
      abc_id: "",
      father_title: "",
      father_name: "",
      mother_title: "",
      mother_name: "",
      guardian_title: "",
      guardian_name: "",
      guardian_phone_number: "",
      disableStatus: false,
      submitAdditional: false,
      gatAddDetails: [],
      message: "",
      submit_button: false,
      toggle_edit: false,
      loader: true,
    };
  },
  mixins: [countryCodeMixins],
  computed: {
    ...mapGetters(["userInfo", "isAuthenticated"]),
  },
  mounted() {
    this.getAdditionalDetails();
  },
  methods: {
    // Submit additional form api post call
    submitAdditionalDetails() {
      const basicData = {
        catagory: this.category,
        name_as_aadhar: this.aadhar_card_name,
        blood_group: this.blood_group,
        mother_tongue: this.mother_tongue,
        marital_status: this.marital_status,
        abc_id: this.abc_id,
        fathers_title: this.father_title,
        fathers_name: this.father_name,
        mothers_title: this.mother_title,
        mothers_name: this.mother_name,
        guardians_title: this.guardian_title,
        guardians_name: this.guardian_name,
        country_code: this.selectedCountryCode,
        guardian_mobile: this.guardian_phone_number,
      };
      console.log("basicData 810", basicData);
      if (this.toggle_edit == false) {
        axios
          .post(
            `${process.env.VUE_APP_API}/additional-information-create/?Key=${this.userInfo.data.token}`,
            basicData
          )
          .then((resp) => {
            if (resp.data.status == 200) {
              this.message = resp.data.message;
              this.disableStatus = true;
              this.submitAdditional = true;
              this.getAdditionalDetails();
              this.$emit("formCompleted");
              setTimeout(() => {
                this.message = "";
              }, 3000);
            } else if (resp.data.status == 400) {
              this.error_message = resp.data.message;
            }
          })
          .catch((err) => {
            console.log("error", err);
          });
      } else {
        axios
          .put(
            `${process.env.VUE_APP_API}/additional-information-update-retrieve/${this.userInfo.data.user.id}/?Key=${this.userInfo.data.token}`,
            basicData
          )
          .then((resp) => {
            if (resp.data.status == 200) {
              this.message = resp.data.message;
              // this.submitAdditional = true;
              this.toggle_edit = false;
              this.disableStatus = true;
              this.getAdditionalDetails();
              setTimeout(() => {
                this.message = "";
              }, 3000);
            } else if (resp.data.status == 400) {
              this.error_message = resp.data.message;
            }
          })
          .catch((err) => {
            console.log("error", err);
          });
      }
    },
    // get Additional data
    getAdditionalDetails() {
      axios
        .get(
          `${process.env.VUE_APP_API}/additional-information-update-retrieve/${this.userInfo.data.user.id}/?Key=${this.userInfo.data.token}`
        )
        .then((resp) => {
          if (resp.data.status === 200) {
            const details = resp.data.data;
            this.loader = false;
            this.toggle_edit = false;

            if (details.user != null) {
              this.gatAddDetails = details;

              this.category = this.gatAddDetails.catagory || details.catagory;
              this.aadhar_card_name =
                this.gatAddDetails.name_as_aadhar || details.name_as_aadhar;
              this.blood_group =
                this.gatAddDetails.blood_group || details.blood_group;
              this.mother_tongue =
                this.gatAddDetails.mother_tongue || details.mother_tongue;
              this.marital_status =
                this.gatAddDetails.marital_status || details.marital_status;
              this.abc_id = this.gatAddDetails.abc_id || details.abc_id;
              this.father_title =
                this.gatAddDetails.fathers_title || details.fathers_title;
              this.father_name =
                this.gatAddDetails.fathers_name || details.fathers_name;
              this.mother_title =
                this.gatAddDetails.mothers_title || details.mothers_title;
              this.mother_name =
                this.gatAddDetails.mothers_name || details.mothers_name;
              this.guardian_title =
                this.gatAddDetails.guardians_title || details.guardians_title;
              this.guardian_name =
                this.gatAddDetails.guardians_name || details.guardians_name;
              this.selectedCountryCode =
                this.gatAddDetails.country_code || details.country_code;
              this.guardian_phone_number =
                this.gatAddDetails.guardian_mobile || details.guardian_mobile;
              // if (
              //   this.gatAddDetails.is_form_completed &&
              //   this.gatAddDetails.is_form_two_filled
              // ) {
              //   this.submitAdditional = false;
              //   this.toggle_edit = false;
              //   this.disableStatus = true;
              //   this.submit_button = true;
              // } else if (
              //   this.gatAddDetails.is_form_completed != true &&
              //   this.gatAddDetails.is_form_two_filled == true
              // ) {
              //   this.toggle_edit = false;
              //   this.submitAdditional = true;

              //   this.disableStatus = true;
              // } else {
              //   this.submitAdditional = false;
              //   this.disableStatus = false;
              // }
              if (this.gatAddDetails.is_form_two_filled == true) {
                this.submitAdditional = true;
                this.disableStatus = true;
                this.toggle_edit = false;
              }
            }
          } else {
            this.loader = false;
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    },
    toggleEdit() {
      this.disableStatus = false;
      this.submitAdditional = false;
      this.toggle_edit = true;
    },
  },
};
</script>

<style></style>
